import React, { FC } from "react";

import { classNames } from "@/shared/utils/classnames";
import { InputWithCornerHint } from "../atoms/InputWithCornerHint";
import { ButtonSecondary } from "../atoms/ButtonSecondary";
import { useTranslation } from "react-i18next";

export type PlanListProps = JSX.IntrinsicElements["ul"] & {
  isLoading: boolean;
  onSearchChange: (search: string) => void;
  onPaymentMethodsClick: () => void;
  onPaymentIntentsClick: () => void;
  onInvoicesClick: () => void;
  onContractClick: () => void;
  onBillingInformationClick: () => void;
  search: string;
};

export const PlanList: FC<PlanListProps> = ({
  onSearchChange,
  onPaymentMethodsClick,
  onPaymentIntentsClick,
  onInvoicesClick,
  onContractClick,
  onBillingInformationClick,
  search,
  className,
  ...props
}) => {
  const [t] = useTranslation();

  return (
    <div>
      <div className="flex flex-col gap-2 md:flex-row sm:items-center">
        <div className="flex w-full md:w-64">
          <InputWithCornerHint
            label={t("general.search")}
            className="w-full"
            placeholder={t("contexts.billing.subscription")}
            onChange={(event) => onSearchChange(event.target.value)}
            value={search}
          />
        </div>
        <div className="mt-8 sm:ml-auto sm:mt-4 flex flex-col gap-2 md:flex-row sm:items-center">
          <ButtonSecondary
            onClick={onContractClick}
            size="large"
            text={t("contexts.billing.contract")}
            className="flex flex-wrap justify-center"
          />
          <ButtonSecondary
            onClick={onBillingInformationClick}
            size="large"
            text={t("contexts.billing.billing_information")}
            className="flex flex-wrap justify-center sm:min-w-48"
          />
          <ButtonSecondary
            onClick={onInvoicesClick}
            size="large"
            text={t("contexts.billing.invoices")}
          />
          <ButtonSecondary
            onClick={onPaymentMethodsClick}
            size="large"
            text={t("contexts.billing.payment_methods")}
            className="flex flex-wrap justify-center sm:min-w-40"
          />
          <ButtonSecondary
            onClick={onPaymentIntentsClick}
            size="large"
            text={t("contexts.billing.payment_intents")}
            className="flex flex-wrap justify-center sm:min-w-40"
          />
        </div>
      </div>
      <ul
        role="list"
        className={classNames(
          "divide-y divide-gray-200 border-t border-gray-300 mt-5",
          className
        )}
        {...props}
      />
    </div>
  );
};
